<template>
    <div
      class="w-full h-auto flex flex-col"
      style="align-items: center"
    >
      <div
        class="w-5/12 h-auto mt-5 mb-5 flex"
        style="justify-content: center"
      >
        <icon
          icon-name="illustration_approval"
          class-name="icon-Size mb-4 mt-4 text-white"
        />
      </div>
      <div
        class="w-6/12 h-auto text-center"
        style="width: 610px; line-height:19px"
      >
      <p class="font-semibold text-base text-flame">
          There are no approval requests at the moment
      </p>
        <p class="mt-5 mb-5 tracking-wide">
            You can track approval progress here until completion,
            after which they will be moved to history.
             Approval flows are complete when approver dissaproves or
             all approvers approve the action/form.
             </p>
      </div>
    </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "EmptyRequests",
  components: {
    Icon,
  },
};
</script>

<style scoped>
.icon-Size {
  width: 200px;
  height: 200px;
}
</style>
